export default __webpack_public_path__ + "static/media/400.f25a868b.png";